import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="bg-[#FBF7F0] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-175">
      <div className="mx-auto max-w-5xl" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10" data-id="element-177">
          <h2 className="mb-4 font-serif text-5xl font-bold tracking-tight text-[#2D2D2D] sm:text-6xl lg:text-7xl" data-id="element-178">
            BACK TO YOU
          </h2>
          <p className="mb-6 font-sans text-xl font-bold uppercase tracking-widest text-[#D4603A]" data-id="element-179">
            The Postpartum Identity & Body Restoration Method
          </p>
          <p className="mx-auto max-w-2xl font-serif text-2xl italic text-[#2D2D2D]/80" data-id="element-180">
            How to reclaim your body, your energy, and your identity in 90 days
            — even if you haven't slept more than 4 hours straight.
          </p>
        </motion.div>

        <div className="grid gap-10 lg:grid-cols-2 lg:items-center" data-id="element-181">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="order-2 lg:order-1 space-y-6 font-sans text-lg leading-relaxed text-[#2D2D2D]/90" data-id="element-182">
            <p className="font-serif text-2xl font-bold text-[#2D2D2D]" data-id="element-183">
              This wasn't built in a luxury gym by someone who's never had
              children.
            </p>
            <p className="font-serif text-2xl italic text-[#D4603A] mb-8" data-id="element-184">
              It was built on a closet floor.
            </p>
            <p data-id="element-185">
              The day I tried to put on my favorite jeans and they wouldn't go
              past my thighs, I sat down and cried for twenty minutes. And it
              wasn't about the jeans. It was about the feeling that I had given
              everything I had — my body, my sleep, my identity, my sense of
              self — and somehow come out of it feeling less than who I was
              before.
            </p>
            <p className="font-bold" data-id="element-186">That day, I made a decision.</p>
            <p data-id="element-187">
              Not to "get my body back." That body was gone. That version of me
              was gone. And that was okay.
            </p>
            <p data-id="element-188">
              What I decided was to build something better. A version of myself
              that had been through the fire and came out knowing things the old
              version never could.
            </p>
            <p data-id="element-189">
              I spent months studying postpartum physiology, hormonal nutrition,
              diastasis rehabilitation, identity psychology, and sleep
              optimization for mothers. I tested everything. I documented
              results. I rebuilt myself from the inside out.
            </p>
            <p data-id="element-190">And then I helped other mothers do the same.</p>
            <div className="mt-8 border-l-4 border-[#E8A838] pl-6 py-2" data-id="element-191">
              <p className="font-serif text-xl font-bold text-[#2D2D2D]" data-id="element-192">
                Back To You is the exact system that came from that process.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="order-1 lg:order-2 relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-193">
            <div className="relative aspect-square overflow-hidden rounded-2xl shadow-2xl" data-id="element-194">
              <img src="https://cdn.magicpatterns.com/uploads/sEBWZC8biHn2vziboGzLxk/BACK_TO_YOU.png" alt="Back To You Program Interface" className="absolute inset-0 h-full w-full object-cover" data-id="element-195" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}